///////////////////////////
// utils
///////////////////////////
export const download = (url, filename) => {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename || "HiKs_animation";
    anchor.click();
};
///////////////////////////
// MATH
///////////////////////////
export  function pow2(x){return x*x}
export  function tovec2(n){return vec2(n,n)}
export class Vec2 {
	constructor(options){
		if(!options) options = {}
		this.x = options.x ? options.x : 0
		this.y = options.y ? options.y : 0
	}
	dot(v){ return this.x*v.x + this.y*v.y }
	mul(v){return vec2(this.x*v.x,this.y*v.y)}
	sub(v){return vec2(this.x-v.x,this.y-v.y)}
	add(v){return vec2(this.x+v.x,this.y+v.y)}
	div(v){return vec2(this.x/v.x,this.y/v.y)}
	squared(){return vec2(this.x*this.x,this.y*this.y)}
	length(){ return distance(vec2(this.x,this.y),vec2(0,0)) }
	normalized(){ return vec2(this.x/this.length(), this.y/this.length()) }
	norm(){return Math.sqrt(pow2(this.x)+pow2(this.y))}
	reflect(normal){
		return this.sub(normal.mul(tovec2(this.dot(normal)*2)))
	}
}
export function distance(a,b){
	return Math.sqrt(pow2(b.x-a.x) + pow2(b.y-a.y))
}

export  function vec2(x,y){
	return new Vec2({x,y})
}
export  function rotate2D(cx, cy, x, y, angle) {
    var radians = angle,
      cos = Math.cos(radians),
      sin = Math.sin(radians),
      nx = cos * (x - cx) + sin * (y - cy) + cx,
      ny = cos * (y - cy) - sin * (x - cx) + cy;
    return { x: nx, y: ny };
  }